export default "__VITE_ASSET__sMiWyBPa__"